import { Component, NgModule } from "@angular/core";
import { UntilDestroy } from "@ngneat/until-destroy";
import { environment } from "src/environments/environment";

@UntilDestroy()
@Component({
  selector: "rs-copyright-component",
  templateUrl: "./copyright.component.html",
  styleUrl: "./copyright.component.scss",
  standalone: true
})
export class CopyrightComponent {
  customerFacingVersion = environment.customerFacingVersion;
  currentYear = new Date().getFullYear();

  navigationInitialized = false;
  logos = environment.logos;
}

@NgModule({})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class CopyrightComponentModule {}
